import { ISalesTeam, SalesTeam } from '@user/store/salesTeam'

export function getSalesTeamOptionInputLabel(
  salesTeam: ISalesTeam | SalesTeam,
) {
  const { name, branchName } = salesTeam

  return branchName && branchName.trim().length > 0
    ? `${name} - ${branchName}`
    : `${name}`
}
